import { connect } from 'react-redux';
import BranchFormWrapper from "../components/general/BranchFormWrapper";
import { ADD_BRANCH, UPDATE_BRANCH } from "../store/actions/branch";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ADD_BRANCH: body => dispatch(ADD_BRANCH(body)),   
        UPDATE_BRANCH: body => dispatch(UPDATE_BRANCH(body)),  
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BranchFormWrapper);


// WEBPACK FOOTER //
// ./src/containers/BranchForm.js